module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-1-medium-fc1f77f2f0c149e5d0f234930c5806a0.jpg";